import { render, staticRenderFns } from "./PlateauxSection.vue?vue&type=template&id=381de35a&scoped=true"
import script from "./PlateauxSection.vue?vue&type=script&lang=js"
export * from "./PlateauxSection.vue?vue&type=script&lang=js"
import style0 from "./PlateauxSection.vue?vue&type=style&index=0&id=381de35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381de35a",
  null
  
)

export default component.exports